import { createFileRoute } from '@tanstack/react-router'
import { ProcessingContractList } from '../components/processing-contracts/ProcessingContractList'

export const Route = createFileRoute('/_a/processingContracts')({
  component: ProcessingContractList,
})
